import { Button, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import Gene20Box from "../../Components/Gene20Box/Gene20Box";

export default function Navigation() {
  const useStyles = makeStyles(() => ({
    buttons: {
      width: "50vw",
      fontSize: "10px",
    },
  }));
  const classes = useStyles();

  return (
    <Gene20Box>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sx={{ display: "block" }}
          className={classes.buttons}
        >
          <Button variant="contained" sx={{ width: "50%" }}>
            create a virtual shop
          </Button>
        </Grid>
        <Grid item xs={12} className={classes.buttons}>
          <Button variant="contained" sx={{ width: "50%" }}>
            explore virtual shops and offices
          </Button>
        </Grid>
      </Grid>
    </Gene20Box>
  );
}
